import {Flex, Text} from '@priority-software/priority-style-react';
import React from 'react';
import styles from '../../../styles.module.scss';
import texts from '../../../texts';
import {reportGeneratorsStore} from '../../../stores/ReportGeneratorsStore';

const GaugeMetrics = ({chartInfo}) => {
    const {isGauge} = reportGeneratorsStore?.currentScreen;

    const getMetricValue = (fieldId: number) => {
        return chartInfo?.scales?.fieldsMap[fieldId][1]?.currentValue ?? '--';
    };

    const metricsValues = [
        {title: texts.baseValue, value: getMetricValue(2)},
        {title: texts.endOfRedArea, value: getMetricValue(3)},
        {title: texts.endOfYellowArea, value: getMetricValue(4)},
        {title: texts.endOfGreenArea, value: getMetricValue(5)},
        {title: texts.endOfWhiteArea, value: getMetricValue(6)}
    ];

    const color = chartInfo?.scales ? 'primary-700' : 'secondary-300';

    if (isGauge) {
        return (
            <div className={styles.metricsWrapper}>
                {metricsValues.map((metric, idx) => (
                    <Flex
                        key={idx}
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        componentClasses={styles.axisWrapper}
                    >
                        <Text skin="label-1" textColor={color}>
                            {metric.title}
                        </Text>
                        <Text componentClasses={styles.metric}>{metric.value}</Text>
                    </Flex>
                ))}
            </div>
        );
    } else {
        return null;
    }
};

export default GaugeMetrics;
